import { HttpStatus } from "../../../../../../shared/frontend/api/httpStatus";

/**
 * HTTP-Statuscodes für API-Fehlerbehandlung.
 * Werte, die Shared führt, kommen aus `shared/frontend/api/httpStatus`; hier stehen nur die übrigen.
 */
export const HTTP_STATUS_NO_CONTENT = HttpStatus.NoContent;
export const HTTP_STATUS_UNAUTHORIZED = HttpStatus.Unauthorized;
export const HTTP_STATUS_FORBIDDEN = HttpStatus.Forbidden;
export const HTTP_STATUS_NOT_FOUND = HttpStatus.NotFound;
export const HTTP_STATUS_REQUEST_TIMEOUT = 408;
export const HTTP_STATUS_CONFLICT = HttpStatus.Conflict;
export const HTTP_STATUS_TOO_MANY_REQUESTS = HttpStatus.TooManyRequests;
export const HTTP_STATUS_BAD_REQUEST = HttpStatus.BadRequest;
export const HTTP_STATUS_REQUEST_ENTITY_TOO_LARGE = 413;
export const HTTP_STATUS_SERVICE_UNAVAILABLE = HttpStatus.ServiceUnavailable;
export const HTTP_STATUS_INTERNAL_SERVER_ERROR = HttpStatus.InternalServerError;
export const HTTP_STATUS_BAD_GATEWAY = 502;
export const HTTP_STATUS_GATEWAY_TIMEOUT = 504;
